import React, { FunctionComponent } from "react"
import { Fade } from "react-slideshow-image"
import "react-slideshow-image/dist/styles.css"
import "./gallery.css"

const fadeImages = [
  {
    image:
      window.location.origin + "/galleryImages/stari dizajn - front view.jpg",
  },
  {
    image:
      window.location.origin + "/galleryImages/stari dizajn - side view.jpg",
  },
  {
    image: window.location.origin + "/galleryImages/interior - new render.jpg",
  },
  {
    image:
      window.location.origin + "/galleryImages/interior 1 - univerzalni.jpg",
  },
  {
    image:
      window.location.origin + "/galleryImages/interior 2 - univerzalni.jpg",
  },
  {
    image: window.location.origin + "/galleryImages/Stari render - terasa.jpg",
  },
]

interface iProps {
  onShowGallery: () => void
}

const Gallery: FunctionComponent<iProps> = ({ onShowGallery }) => {
  return (
    <div className="gallery_holder">
      {/* <div className="logo-wrap">
        <div className="logo-container">
          <img src={window.location.origin + "/gtc-x-logo.png"} alt="" />
        </div>
        <div className="logotip-container">
          <img src={window.location.origin + "/gtc-x-logotip.png"} alt="" />
        </div>
      </div> */}
      <Fade
        autoplay={false}
        indicators={true}
        duration={3000}
        transitionDuration={500}
        pauseOnHover={true}
        arrows={true}
        defaultIndex={0}
        canSwipe={true}
      >
        <div className="each-fade">
          <div className="image-container">
            <img src={fadeImages[0].image} />
          </div>
        </div>
        <div className="each-fade">
          <div className="image-container">
            <img src={fadeImages[1].image} />
          </div>
        </div>
        <div className="each-fade">
          <div className="image-container">
            <img src={fadeImages[2].image} />
          </div>
        </div>
        <div className="each-fade">
          <div className="image-container">
            <img src={fadeImages[3].image} />
          </div>
        </div>
        <div className="each-fade">
          <div className="image-container">
            <img src={fadeImages[4].image} />
          </div>
        </div>
        <div className="each-fade">
          <div className="image-container">
            <img src={fadeImages[5].image} />
          </div>
        </div>
      </Fade>

      <div
        className="gallery_close"
        onClick={() => {
          onShowGallery()
        }}
      >
        <img src={window.location.origin + "/icons/close.png"} alt="" />
      </div>
    </div>
  )
}

export default Gallery
